<div class="param-container">

  @if (param.type === 'number') {

  <div class="number_input">
    <mat-form-field>
      <mat-label>{{param.name}}</mat-label>
      <input matInput [formControl]="fc" type="number" [name]=param.name [min]=param.min [max]=param.max step=1>
      @if (fc.invalid && (fc.dirty || fc.touched)) {
      @if (fc.hasError('required')) {
      <mat-error>a value between {{param.min}} and {{param.max}} is required</mat-error>
      }
      @if (fc.hasError('min')) {
      <mat-error>value must be greater than {{param.min}}</mat-error>
      }
      @if (fc.hasError('max')) {
      <mat-error>value must be less than {{param.max}}</mat-error>
      }
      }
    </mat-form-field>
  </div>

  }


  <!-- Canvas parameter container -->
  @if (param.type === 'p5-canvas') {
  <div class="p5-canvas-parameter">
    <div #p5canvasContainer class="p5-canvas-container"></div>
  </div>

  }
  @if (param.type == 'select') {
  <div class="select-input">
    <mat-form-field>
      <mat-label>{{param.name}}</mat-label>
      <mat-select [panelWidth]="auto" [formControl]="fc">
        @for (opt of param.selectlist; track opt) {
        <mat-option [value]="opt.value">
          {{opt.name}}
        </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
  }

  @if (param.type == 'boolean') {
  <div class="boolean-input">
    <mat-form-field>
      <mat-label>{{param.name}}</mat-label>
      <mat-select [panelWidth]="auto" [formControl]="fc">
        <mat-option [value]="1">
          {{param.truestate}}
        </mat-option>
        <mat-option [value]="0">
          {{param.falsestate}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  }

  @if (param.type == 'string') {
  <div class="string-input">

    <button matFab extended (click)="openTextEditor()">
      <div class="string_button_container">
        <div class="string_param_name">{{param.name}}</div>
        <div class="string_param_value"><i class="fas fa-edit"></i> {{opnode.params[paramid]}}</div>
      </div>
    </button>
  </div>
  }



  @if (param.type == 'file') {
  <div class='file-input-param'>
    <div class="form-and-warning">
      <button mat-raised-button [class.show]="has_image_uploaded" [class.hide]="!has_image_uploaded"
        (click)="replaceImage()">Replace Image</button>
      <upload-form [class.show]="!has_image_uploaded" [class.hide]="has_image_uploaded" type="init" multiple="false"
        accepts=".jpg,.png,.bmp" type="indexed_color_image" (onData)="handleFile($event)"
        (onError)="handleError($event)" class="upload-form-box">
      </upload-form>
      <div class="file-label">
        @if (filewarning !== '') {
        <div class="text-err">{{filewarning}}</div>
        }
      </div>
    </div>
    <div class='param-image' [class.show]="has_image_uploaded" [class.hide]="!has_image_uploaded"
      id="param-image-{{opid}}">
      <button color="accent" mat-raised-button (click)="openImageEditor()">View/Edit Image</button>
    </div>
  </div>
  }
</div>